import { useTranslation } from "next-i18next"
import SignAdvantageItems from "../SignAdvantageItems"

function AdvantagesList() {
  const { t } = useTranslation("common")

  const list = [
    {
      image: "🔄",
      title: t("SIGNIN_CONTINUE_JOURNEY_TITLE"),
      description: t("SIGNIN_CONTINUE_JOURNEY_DESC"),
    },
    {
      image: "🔑",
      title: t("SIGNIN_EASY_ACCESS_TITLE"),
      description: t("SIGNIN_EASY_ACCESS_DESC"),
    },
    {
      image: "📈",
      title: t("SIGNIN_ONGOING_GROWTH_TITLE"),
      description: t("SIGNIN_ONGOING_GROWTH_DESC"),
    },
  ]

  return <SignAdvantageItems items={list} />
}

export default AdvantagesList
